<template>
    <div class="header-bar w-full bg-white flex flex-space-evenly">
        <WFBuildingLogo class="grow-0 shrink-1 basis-1/4"/>
        
        <div class="flex-spacer"></div>
        <div class="header-dt">
            <WFClock />
            <WFDate format="ddd. DD. MMM"/>
        </div>
        <div class="flex-spacer"></div>
    </div>
</template>

<script>
import { WFBuildingLogo, WFClock, WFDate } from '@3dwayfinder/wayfinder-vue-components'

export default {
    name: 'THHeader',
    components: {
		WFBuildingLogo,
        WFClock,
        WFDate
    }
}
</script>

<style lang="less">
    @import '../css/variables';

    .wf-building-logo {
        background-position: 0 50% !important;
    }
    .header-dt {
        text-align: right;
        flex-shrink: 0;
    }
    .wf-clock {
        font-size: 5.8rem;
		color: @font-color;
		font-weight: 500;
    }

    .wf-date {
        font-size: 2.4rem;
        font-weight: 500;
    }
</style>